var React = require('react');

function Shape3 (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fill":"#E4D3C8","d":"M157.149-1.323c0,0-104.563-13.521-121.688,19.83\n\t\tC18.336,51.859-8.815,53.267,2.806,85.844c15.53,43.534,63.305,12.886,90.346-5.141s36.124-36.957,60.462-18.929\n\t\tc24.338,18.028-2.869,41.82,26.071,84.617c27.942,41.32,80.197,19.718,96.447,0c16.25-19.717,27.943-31.97,11.719-60.547\n\t\ts-17.127-34.887-0.901-50.21c16.226-15.324,40.563-39.668,40.563-39.668L157.149-1.323z"})));
}

Shape3.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","width":"327.512px","height":"169.958px","viewBox":"0 0 327.512 169.958","enableBackground":"new 0 0 327.512 169.958","xmlSpace":"preserve"};

module.exports = Shape3;

Shape3.default = Shape3;
